// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"0bd419b6","787":"b8fd727c"}[chunkId] + ".chunk.js";
};